import { debateConfig } from '../../config';

const originalConsoleLog = console.log;

/**
 * Logs a message only if the environment is local or scalingo
 */
export const devLogger = (...args: any[]) => {
  if (['local', 'scalingo'].some(el => el === debateConfig.env)) {
    originalConsoleLog('[DEV_LOGGER]', ...args);
  }
};
